@switch (flowType) {
@case (flowTypeEnum.Standard) {
<ng-container *ngTemplateOutlet="standardTemplate" />
}
@case (flowTypeEnum.Refund) {
<ng-container *ngTemplateOutlet="refundTemplate" />
}
@default {
<ng-container *ngTemplateOutlet="standardTemplate" />
}
}

<ng-template #standardTemplate>
  <div class="container p-0">
    <div class="d-flex head-inner justify-content-between w-100 px-3 px-md-9">
      <div class="logocontainer brand col-9 col-sm-6">
        <a href="{{env.siteUrl}}">
          <picture>
            <img src="/assets/images/logo/main-logo.png" alt="Logo">
          </picture>
        </a>
      </div>
      <div class="text-sm-end">
        <app-user-status></app-user-status>
      </div>
    </div>
  </div>
  <app-order-background-component></app-order-background-component>
</ng-template>

<ng-template #refundTemplate>
  <div class="container p-0">
    <div class="d-flex head-inner justify-content-end w-100 px-3 px-md-9">
      <div class="logocontainer brand">
        <a href="{{env.siteUrl}}">
          <picture>
            <img src="/assets/images/logo/main-logo.png" alt="Logo">
          </picture>
        </a>
      </div>
    </div>
  </div>
  <app-order-background-component></app-order-background-component>
</ng-template>